<template>
  <svg
    class="color-pick-icon"
    :style="`background: ${bgColor}`"
    width="22px"
    height="22px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>字体颜色</title>
    <g
      id="翻译页面"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="轻翻译-富文本-添加文字背景色"
        transform="translate(-617.000000, -164.000000)"
      >
        <g id="字体颜色备份-5" transform="translate(618.000000, 165.000000)">
          <g
            id="编组-15"
            transform="translate(6.451453, 5.353529)"
            :stroke="fontColor"
            stroke-linejoin="round"
            stroke-width="1.32"
          >
            <path
              d="M0,11.6464707 L4.51863708,0 L9.03347559,11.6464707 M1.99334035,6.6314707 L7.11076585,6.6314707"
              id="形状结合"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fontColor: {
      type: String,
    },
    bgColor: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.color-pick-icon {
  cursor: pointer;
  border-radius: 2px;
  &.anchor {
    background: #f1f1f1;
  }
}
</style>
